import { checkExtension, ExtensionMetadata, ExtensionType, Loader, LoaderParser, LoaderParserPriority, ResolvedAsset } from "pixi.js";
import { PromiseCompletionSource } from "scene-manager";
import { Mesh, Texture } from "three";
import { GLTFLoader as ThreeGLTFLoader, GLTF } from "three/examples/jsm/loaders/GLTFLoader.js";

export class GLTFLoader implements LoaderParser<GLTF> {

    public readonly name: string;
    public readonly extension: ExtensionMetadata;

    private readonly loader: ThreeGLTFLoader;

    public constructor() {
        this.name = `gltf_loader`;
        this.extension = {
            type: ExtensionType.LoadParser,
            priority: LoaderParserPriority.High
        };
        this.loader = new ThreeGLTFLoader();
    }

    public test(url: string): boolean {
        return checkExtension(url, [".glb", ".gltf"]);
    }

    public async load<T>(url: string, _resolvedAsset?: ResolvedAsset<Record<string, any>>, _loader?: Loader): Promise<T> {
        const pcs = new PromiseCompletionSource<GLTF>();
        this.loader.load(
            url,
            (result: GLTF) => pcs.complete(result),
            null,
            (reason: unknown) => pcs.error(reason)
        );
        const result = await pcs.result as T;
        return result;
    }

    public unload(asset: GLTF, resolvedAsset?: ResolvedAsset<any>, loader?: Loader): void {
        asset.scene.traverse((child) => {
            if (!(child instanceof Mesh)) {
                return;
            }
            const geometry = child.geometry;
            if (geometry != null) {
                geometry.dispose();
            }
            const material = child.material;
            if (material != null) {
                const materials = Array.isArray(material) ? material : [material];
                for (const mat of materials) {
                    for (const key in mat) {
                        const value = mat[key];
                        if (value instanceof Texture || (value != null && typeof value == "object" && "dispose" in value && typeof value["dispose"] == "function")) {
                            value.dispose();
                        }
                    }
                    mat.dispose?.();
                }
            }
        });
    }
}
